<script>
  import { nlToBr } from '@utils'

  import Layout from '@layouts/main'
  import BookingBanner from '@components/BookingBanner'
  import { authComputed } from '@state/helpers'
  import ModalLogin from '@components/ModalLogin';

  export default {
    page() {
      return {
        title: `${this.merchant.name} | ${this.prepaid.name}`,
      }
    },
    components: { Layout, BookingBanner, ModalLogin },
    filters: {
      nlToBr,
    },
    props: {
      merchant: {
        type: Object,
        required: true,
      },
      prepaid: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        isModalLoginActive: false,
        checkoutProcessing: false,
        defaultImage: require('@assets/images/activity_default.png'),
      }
    },
    computed: {
      ...authComputed,
      discount() {
        const percent = 100 - (100 / Math.abs(this.prepaid.basePrice / this.prepaid.price));
        return `${percent}%`
      },
      canBuy() {
        return this.prepaid.infinity || this.prepaid.qty < this.prepaid.inventory
      }
    },
    methods: {
      handleToPrepaidCheckout(prepaid) {
        if(!this.loggedIn) {
          this.isModalLoginActive = true;
          return false;
        }

        this.checkoutProcessing = true;


        const cart = {
          ...prepaid
        };

        const sessionCart = {
          merchantAlias: this.merchant.alias,
          prepaidAlias: prepaid.alias
        };

        this.$store.dispatch('booking/updateSessionCart', sessionCart)
          .then(() => {
            this.$store.dispatch('booking/updatePrepaidCart', cart);
            this.$router.push({
              name: 'booking-prepaid-checkout',
              params: {prepaidAlias: prepaid.alias},
              query: {
                language: this.$route.query.language,
              }
            })
          })
          .finally(() => {this.checkoutProcessing = false});
      },
    }
  }
</script>
<template>
 <Layout>
   <div class="booking-container">
     <BookingBanner :merchant="merchant"/>
     <div class="booking-section">
       <div class="level subsection is-small">
         <h4
           class="booking-section__title"
         >{{prepaid.name}}</h4>
       </div>
       <div class="hero" style="position: relative">
         <figure>
           <BaseImage
             :src="prepaid.image"
             :error-src="defaultImage"
             :class="$style.banner"
             class-name="is-cover"
           />
         </figure>
         <div :class="$style.styleBlockItem">
           <span class="has-text-white">{{ $t('global.PREPAID_TOTAL_DEDUCT'/*總抵用次數*/) }}</span>
           <h3 class="is-size-4 has-text-white has-text-weight-bold">{{prepaid.times}}</h3>
         </div>
       </div>
       <!--<div class="subsection">
         <div :class="$style.styleBlockList">
           <div :class="$style.styleBlockItem">
             <h3 class="is-size-4 has-text-primary">{{prepaid.times}}</h3>
             <span class="has-text-grey-light">{{ $t('global.PREPAID_TOTAL_DEDUCT'/*總抵用次數*/) }}</span>
           </div>
           <div :class="$style.styleBlockItem">
             <h3 class="is-size-4 has-text-primary">{{discount}}</h3>
             <span class="has-text-grey-light">最高較單次購買優惠</span>
           </div>
           <div :class="$style.styleBlockItem">
             <h3 class="is-size-4 has-text-primary">{{prepaid.applicablePricesCounts}}</h3>
             <span class="has-text-grey-light">可適用項目數</span>
           </div>
         </div>
       </div>-->
       <!--<div v-if="prepaid.description" class="subsection">
         <div class="subsection__title">{{ $t('global.PREPAID_DISCOUNT'/*優惠內容*/) }}</div>
         <div v-html="$options.filters.nlToBr(prepaid.discount)"></div>
       </div>-->
       <div v-if="prepaid.description" class="subsection">
         <div class="subsection__title">{{ $t('global.PREPAID_DESCRIPTION'/*內容說明*/) }}</div>
         <div v-html="$options.filters.nlToBr(prepaid.description)"></div>
       </div>
       <div v-if="prepaid.notice" class="subsection">
         <div class="subsection__title">{{ $t('global.PREPAID_TIP'/*注意事項*/) }}</div>
         <div v-html="$options.filters.nlToBr(prepaid.notice)"></div>
       </div>
       <div class="subsection">
         <div class="subsection__title">{{ $t('global.PREPAID_APPLICABLE'/*適用課程*/) }}</div>
         <div>
            <ul v-for="(events, key) in prepaid.applicableEvents" :key="key" :class="$style.isRowStyleA">
              <li>
                <span>{{key}}：</span>
                <span v-for="(eventItem, index) in events" :key="index">
                  {{ eventItem }}
                  <span v-if="index < events.length - 1">，</span>
                </span>
              </li>
            </ul>
         </div>
       </div>
     </div>
   </div>
   <div :class="$style['nextStepSection']">
     <transition name="fixed-panel" appear>
       <div :class="$style.panel">
         <div class="booking-container">
           <div class="level">
             <div class="level-left" :class="$style['panel-left']">
               <div class="has-text-primary">{{ $t(`product.prepaid.TEXT_CHECKOUT` /* 前往下一步填寫預訂資訊 */) }}</div>
               <div
                 :class="$style['panel-left__total']"
               >
                 <span v-if="prepaid.basePrice > prepaid.price" :class="$style['basePrice']" class="has-text-grey-light">原價 ${{prepaid.basePrice}}</span>
                 {{ $t('global.TOTAL'/*總計*/) }} ${{prepaid.price}}
               </div>
             </div>
             <template>
               <b-button
                 v-if="canBuy"
                 type="is-primary"
                 rounded
                 class="fix-width-200"
                 :loading="checkoutProcessing"
                 @click="handleToPrepaidCheckout(prepaid)"
               >{{ $t(`product.prepaid.BUTTON_BOOK_NOW` /* 立即購買 */) }}</b-button>
               <b-button
                 v-else
                 type="is-static"
                 rounded
                 class="fix-width-200"
               >{{ $t(`product.prepaid.BUTTON_SOLD_OUT` /* 已售完 */) }}</b-button>
             </template>
           </div>
         </div>
       </div>
     </transition>
   </div>
   <b-modal
     custom-class="is-login-style"
     :active.sync="isModalLoginActive"
     :width="370"
     :can-cancel="['escape','outside']">
     <ModalLogin @close="isModalLoginActive = false" @login="handleToPrepaidCheckout(prepaid)"/>
   </b-modal>
   <!--<b-loading :is-full-page="true" :active.sync="checkoutProcessing"></b-loading>-->
 </Layout>
</template>
<style lang="scss" module>
  .banner {
    width: 100%;
    height: 300px;
  }
  .styleBlockItem {
    background: rgba($color-primary, 0.85);
    color: #fff;
    border-radius: 5px;
    padding: 0.5rem 1rem;
    text-align: right;
    position: absolute;
    right: 1rem;
    bottom: 1rem;
  }
  .isRowStyleA {
    padding-left: 1.2rem;
    > li {
      list-style: disc;
      margin-bottom: 0.5rem;
    }
  }
  .nextStepSection {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 6;
    width: 100%;

    @include mobile {
      :global(.level) {
        display: inline-flex;
      }
    }
    .panel {
      @extend %typography-medium;

      padding: 10px 18px;
      overflow-x: scroll;
      color: $grey;
      background: white;
      border-top: 1px solid $color-border-base;
      &-left {
        flex-grow: 1;
        justify-content: space-between;
        &__total {
          margin-right: 1.5rem;
        }
      }
      .basePrice {
        font-size: 13px;
        text-decoration: line-through;
      }
    }
  }
</style>
